import { JobTypeVersion, Material, RelatedJob } from './jobTemplateTypes';
import PriceType, { TotalPriceType } from './priceType';
import { PanelType, RoofType } from '/modules/solar/types/ConfiguredRoofType';
import SolarJobLocation from '/modules/solar/types/SolarJobLocation';
import { Answers, JobTemplateType } from './jobTemplateTypes';
import Image from './imageType';
import { DeepPartial } from './utils';

export enum LineItemType {
    JOB = 'JOB',
    CUSTOM_JOB = 'CUSTOM_JOB',
    CLAIM_JOB = 'CLAIM_JOB',
    SOLAR_JOB = 'SOLAR_JOB',
    DISCOUNT_CODE = 'DISCOUNT_CODE',
    SYSTEM_DISCOUNT = 'SYSTEM_DISCOUNT',
    ALTERATION = 'ALTERATION',
}

export interface LineItem {
    createdAt: string;
    data: any;
    id: number;
    name: string;
    reference: string;
    total: PriceType;
    type: LineItemType;
    updatedAt: string;
    workHours: number;
}

export interface SolarJobLineItem extends LineItem {
    type: LineItemType.SOLAR_JOB;
    data: {
        answers: any[];
        jobTypeId: number;
        jobTypeVersion: JobTypeVersion;
        materials: Material[];
        materialsEdited?: boolean;
        metaData: {
            location: SolarJobLocation;
        };
        totals: TotalPriceType;
        roofAnswers: {
            selectedRoofs: {
                id: number;
                panelQty: number;
                panelType: PanelType['value'];
                roofType: RoofType['value'];
                yearlyProduction: number;
            }[];
        };
    };
}

export interface TemplateJobLineItem extends LineItem {
    type: LineItemType.JOB;
    data: {
        answers: Answers;
        jobTypeId: number;
        jobTypeVersionId: number;
        jobTypeVersion: JobTypeVersion;
        order: number;
        published: boolean;
        materials: Material[];
        materialsEdited?: boolean;
        editedMaterialList: Material[] | null;
        totals: TotalPriceType;
        images: Image[];
        importantInformation: string;
        revisionRequired?: boolean;
        vismaArticleNumber: string | null;
        workHours: number;
        commentForElectrician: string | null;
        typeKey: JobTemplateType;
        relatedJobs?: RelatedJob[];
    };
}

export type PartialTemplateJobLineItem = DeepPartial<TemplateJobLineItem>;

export interface CustomJobLineItem extends LineItem {
    type: LineItemType.CUSTOM_JOB;
    data: {
        /* FIXME - add missing values */
        [kay: string]: any;
    };
}

export interface ClaimJobLineItem extends LineItem {
    type: LineItemType.CLAIM_JOB;
    data: {
        /* FIXME - add missing values */
        [kay: string]: any;
    };
}

export interface DiscountCodeLineItem extends LineItem {
    type: LineItemType.DISCOUNT_CODE;
    data: {
        /* FIXME - add missing values */
        [kay: string]: any;
    };
    amount: number;
}

export interface SystemDiscountLineItem extends LineItem {
    type: LineItemType.SYSTEM_DISCOUNT;
    data: {
        /* FIXME - add missing values */
        [kay: string]: any;
    };
}

export interface AlterationLineItem extends LineItem {
    type: LineItemType.ALTERATION;
    data: {
        /* FIXME - add missing values */
        [kay: string]: any;
    };
}

export type CartLineItem =
    | TemplateJobLineItem
    | DiscountCodeLineItem
    | SystemDiscountLineItem;

export type AnyLineItem =
    | SolarJobLineItem
    | TemplateJobLineItem
    | CustomJobLineItem
    | ClaimJobLineItem
    | DiscountCodeLineItem
    | SystemDiscountLineItem
    | AlterationLineItem;

export type LineItems = AnyLineItem[];
